import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IntercomTargetModule } from '@y42/intercom';
import { ScrollbarWrapperComponent } from './scrollbar-wrapper.component';

@NgModule({
  imports: [CommonModule, FontAwesomeModule, MatButtonModule, MatProgressSpinnerModule, IntercomTargetModule],
  declarations: [ScrollbarWrapperComponent],
  exports: [ScrollbarWrapperComponent],
})
export class ScrollbarWrapperModule {}
